var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _path2, _ellipse6, _path3, _ellipse7, _path4, _ellipse8, _path5, _ellipse9, _path6, _ellipse10, _path7, _path8, _path9, _circle, _ellipse11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorneArcade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 100 2768 3002.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7bb329;}.cls-2,.cls-3{fill:#00963b;}.cls-3{opacity:0.36;}.cls-4{fill:#c7d301;}.cls-5{fill:#b1c907;}.cls-6{fill:#444;}.cls-7{fill:#353535;}.cls-8{fill:#6d1616;}.cls-9{fill:#9b1818;}.cls-10{fill:#5e5e5e;}.cls-11{fill:#c6c6c6;}.cls-12{fill:#efefef;}.cls-13{fill:#e55441;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "borne d&amp;apos;arcade") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2403 2830.65 2372 579.65 2543 448.65 2540 101.65 1364.23 101.65 1340 101.65 228 101.65 225 448.65 396 579.65 365 2830.65 0 3054.65 0 3101.65 1267 3101.65 1384 3101.65 2768 3101.65 2768 3054.65 2403 2830.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2362 2837.65 2332 570.65 2450 490.65 1384 490.65 318 490.65 436 570.65 406 2837.65 50 3057.65 50.14 3102.07 1384 3102.07 2717.86 3102.07 2718 3057.65 2362 2837.65"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "396 579.65 225 448.65 2543 448.65 2372 579.65 396 579.65"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2263 2915.65 1384 2915.65 1353 2915.65 474 2915.65 299 3060.65 1353 3060.65 1384 3060.65 2438 3060.65 2263 2915.65"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1464 571.65 1295 571.65 474 571.65 474 2915.65 1295 2915.65 1442.68 2915.65 2263.68 2915.65 2285 571.65 1464 571.65"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 578,
    y: 618.65,
    width: 1580,
    height: 2245,
    rx: 104.25
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1408,
    cy: 3006.97,
    rx: 136,
    ry: 29.89
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1821,
    cy: 3006.97,
    rx: 136,
    ry: 29.89
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1610,
    cy: 2940.97,
    rx: 136,
    ry: 29.89
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2023,
    cy: 2940.97,
    rx: 136,
    ry: 29.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1423,2884.32v22.19c0,10.77,45.22,19.49,101,19.49s101-8.72,101-19.49v-22.19Z",
    transform: "translate(-116 101.65)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1408,
    cy: 2985.97,
    rx: 101,
    ry: 22.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M747,2872v27.47c0,13.32,56,24.12,125,24.12s125-10.8,125-24.12V2872Z",
    transform: "translate(-116 101.65)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 756,
    cy: 2973.66,
    rx: 125,
    ry: 27.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M794,2851.63v17.24c0,8.35,34.92,15.13,78,15.13s78-6.78,78-15.13v-17.24Z",
    transform: "translate(-116 101.65)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 756,
    cy: 2953.29,
    rx: 78,
    ry: 17.23
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1630,2817.19v22.2c0,10.76,45.22,19.49,101,19.49s101-8.73,101-19.49v-22.2Z",
    transform: "translate(-116 101.65)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1615,
    cy: 2918.85,
    rx: 101,
    ry: 22.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1832,2884.32v22.19c0,10.77,45.22,19.49,101,19.49s101-8.72,101-19.49v-22.19Z",
    transform: "translate(-116 101.65)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1817,
    cy: 2985.97,
    rx: 101,
    ry: 22.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2039,2817.19v22.2c0,10.76,45.22,19.49,101,19.49s101-8.73,101-19.49v-22.2Z",
    transform: "translate(-116 101.65)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 2024,
    cy: 2918.85,
    rx: 101,
    ry: 22.19
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M899,2533H837l5,316c0,10.72,62,10.72,62,0Z",
    transform: "translate(-116 101.65)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M861.94,2504.77a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-116 101.65)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890.73,2533H875l1.27,324a67.35,67.35,0,0,0,17.73-2Z",
    transform: "translate(-116 101.65)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 751.5,
    cy: 2635.15,
    r: 62
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 886.5,
    cy: 2496.5,
    rx: 10.71,
    ry: 15.65,
    transform: "translate(-1793.84 1932.9) rotate(-55.91)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneArcade);
export default __webpack_public_path__ + "static/media/borne_arcade.70b403d031f146ee33e52c78bd7b82da.svg";
export { ForwardRef as ReactComponent };